import { InvoiceCategoryCode } from "@/models/invoices";
import i18n from "@/i18n";

export const ConditionInvoiceCategories = [
  {
    value: InvoiceCategoryCode.NEW_CONTRACT,
    label: i18n.t("_.initial_invoice")
  },
  {
    value: InvoiceCategoryCode.MIGRATION,
    label: i18n.t("_.migration")
  },
  {
    value: InvoiceCategoryCode.RECURRENT,
    label: i18n.t("_.recurring")
  }
];
